// Centralized testimonials config so client copy can be updated easily
// Replace contents with client-provided copy when ready

const testimonials = [
  {
    name: "Jerry H.",
    text: "Awesome experience booking our travel, tickets, & hotel all in one place. Thanks 40 Bags - Go Sox!",
    rating: 5,
  },
  {
    name: "Paul S.",
    text: "Just booked my hotel in Jacksonville Florida to attend the State High school meet. Easy with 40 Bags!",
    rating: 5,
  },
  {
    name: "Melanie G.",
    text: "We needed multiple accomodations for an out of town graduation. Nice to book everything in one spot.",
    rating: 5,
  },
  {
    name: "Gregg T.",
    text: "Me and some buddies booked a baseball game at O'Brate through Vivid. Great experience; simple tickets",
    rating: 5,
  },
  {
    name: "Mason J.",
    text: "Booked a stay at the Omni in downtown OKC through 40 Bags; heck of a pool party!",
    rating: 5,
  },
  {
    name: "Patrick R.",
    text: "Needed airline tickets fast. Checked multiple resources but ended up with best pricing through 40 Bags!",
    rating: 5,
  },
];

export default testimonials;


